<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('purchaseRequest.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('purchaseRequest.pageTitle'),
          href: '/admin/purchase-requests'
        },
        {
          text: $t('create'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <Info v-model="model" :validate="errors" class="tw-p-3 tw-rounded" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="ts-flex ts-justify-end ts-mb-2">
                  <ts-button color="info" @click.prevent="$refs.templateModal.show()">
                    <i class="fa fa-list ts-mr-1"></i>
                    {{ $t('purchaseRequest.selectTemplate') }}
                  </ts-button>
                </div>
                <ItemList v-model="model" :validate="errors" ref="itemList" class="ts-border ts-rounded" />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
                <ts-button @click.prevent="$router.push({ name: 'purchase-request' })">{{ $t('cancel') }}</ts-button>
                <ts-button color="primary" outline :waiting="loading" @click.prevent="onSaveAddNew">{{
                  $t('savePrint') }}</ts-button>
                <ts-button :waiting="loading" @click.prevent="onSave" color="primary">{{ $t('save') }}</ts-button>
              </div>
            </div>
          </form>
          <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
            <ts-preview-pdf v-model="loading" :src="src" />
          </a-modal>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
    <TemplateModal ref="templateModal" @select="onSelectTemplate" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Info from './components/info.vue'
import ItemList from './components/item-list'
import TemplateModal from './components/template-modal'
import { fileUpload } from '@/api/purchase-request/purchase-request'

export default {
  name: 'purchaseRequestV2Create',
  components: {
    Info,
    ItemList,
    TemplateModal
  },
  data() {
    return {
      loading: false,
      waiting: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      model: {
        pr_date: moment().format('DD-MM-YYYY'),
        pr_by: null,
        required_date: null,
        project_id: null,
        customer_id: null,
        remarks: null,
        details: []
      }
    }
  },
  computed: {
    ...mapState('purchaseRequest/purchaseRequest', ['formViewDatas']),
    products() {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products']
      }
      return []
    },
  },
  methods: {
    ...mapActions('purchaseRequest/purchaseRequest', ['getFormViewModel', 'store']),
    async getPreData({ params, index }) {
      this.loading = true
      await this.getFormViewModel({ index: index, params: params })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => (this.loading = false))
    },
    onSave() {
      this.loading = true
      this.errors = new Errors()
      this.store({ ...this.model, preview: false })
        .then(async (response) => {
          await this.uploadFileRef(response.id)
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.push({ name: 'purchase-request' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },

    onSaveAddNew() {
      this.loading = true
      this.show_pdf = true
      this.errors = new Errors()
      this.store(this.model)
        .then(async (response) => {
          await this.uploadFileRef(response.id)
          this.$toasted.success(response.message)
          this.src = response.url
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    uploadFileRef(prId) {
      const detailRef = this.$refs.itemList
      const formData = new FormData()

      formData.append('pr_main_id', prId)

      if (detailRef && detailRef.fileList && detailRef.fileList.length) {
        detailRef.fileList.forEach(file => {
          formData.append('file[]', file)
        })
      }

      if (detailRef.fileList.length > 0) {
        return fileUpload(formData)
          .then(response => {
            return response
          })
          .catch(error => {
            console.error(error)
            throw error
          })
      }
    },
    clearInput() {
      this.model.pr_date = moment().format('DD-MM-YYYY')
      this.model.pr_by = null
      this.model.pr_status = 0
      this.model.pr_status_by = null
      this.model.remarks = null
      this.model.details = []
      this.model.remarks = null
      this.model.details = []
    },
    onSelectTemplate(template) {
      this.model.details = []
      if (template.details && template.details.length > 0) {
        template.details.forEach((detail, index) => {
          const product = this.products.find(p => p.product_id == detail.product_id)
          if(product) {
            this.model.details.push({
              product_id: product.product_id,
              uom_id: product.uom_id,
              uom_cat_id: product.uom_cat_id,
              quantity: detail.quantity,
              maximum_reorder_allow: product.maximum_reorder_allow,
              alloworder: false,
              input_currency_id: product.input_currency_id,
              currency_id: product.currency_id,
              fx_rate: product.fx_rate,
              fx_rate_ratio: product.fx_rate_ratio,
              input_unit_price: product.input_unit_price
                ? product.input_unit_price
                : 0,
              unit_price: product.unit_price ? product.unit_price : 0,
              input_total: product.input_unit_price * product.quantity,
              total: product.unit_price * product.quantity,
              remarks: null,
              order: index + 1,
              remarks: detail.remarks,
  
            })
          }
        })
        this.$toasted.success('Items added from template')
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData({
        params: {},
        index: undefined
      })
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseRequest/purchaseRequest/SET_EDIT_DATA', {})
    next()
  }
}
</script>
